export default "__VITE_ASSET__CVu63_V1__"